import React, { useEffect } from "react";

const CommonTextField = ({
  label,
  name,
  required = false,
  register,
  errors,
  placeholder = "",
  defaultValue = "",
  setValue,
  readOnly = false,
}) => {
  useEffect(() => {
    if (defaultValue && setValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);
  return (
    <div className="flex flex-col gap-2">
      <label className="font-bold text-base" htmlFor={name}>
        {label}
        {required && <span className="text-red-500 text-xs ml-0.5">*</span>}
      </label>
      <input
        id={name}
        type="text"
        placeholder={placeholder}
        defaultValue={defaultValue}
        readOnly={readOnly}
        {...register(name, { required })}
        className={`border rounded-lg px-[16px] py-[11px] outline-none transition-all
          ${readOnly ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}
          ${errors?.[name]
            ? "border-red-500 focus:border-red-300 focus:ring-red-200"
            : "border-gray-300 focus:border-blue-300 focus:ring-2 focus:ring-blue-200"
          }
        `}
      />
      {errors[name] && (
        <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default CommonTextField;
